import type {
    GovernancePolicyEntity,
    GovernancePolicyFormData,
} from '@experiences/interfaces';
import { PolicyStatus } from '@experiences/interfaces';
import type { PolicyModeValue } from '@experiences/telemetry';

export function mapPolicyStatusToPolicyMode(status: PolicyStatus | undefined): PolicyModeValue {
    switch (status) {
        case PolicyStatus.Active:
            return 'Enabled';
        case PolicyStatus.Disabled:
            return 'Disabled';
        case PolicyStatus.Simulated:
        default:
            return 'Simulation';
    }
}

/**
 * Compares two policy snapshots (form data or persisted entity) and returns a
 * comma-separated list of the top-level fields whose values differ.
 */
export function diffPolicyFields(
    original: Partial<GovernancePolicyFormData | GovernancePolicyEntity>,
    updated: Partial<GovernancePolicyFormData | GovernancePolicyEntity>,
): string {
    const FIELDS: Array<keyof GovernancePolicyFormData> = [
        'name',
        'description',
        'policyType',
        'tenantId',
        'enforcement',
        'status',
        'selectors',
        'actorRule',
        'executableRule',
    ];

    const changed: string[] = [];
    for (const field of FIELDS) {
        const a = original[field as keyof typeof original];
        const b = updated[field as keyof typeof updated];
        if (JSON.stringify(a ?? null) !== JSON.stringify(b ?? null)) {
            changed.push(field);
        }
    }
    return changed.join(', ');
}

